import React from "react";
import { Button, InsetWrap, Title } from "@citydna/common";
import { useAuth } from "./AuthProvider";

export const SignInWarning = () => {
  const { status, requestAuthChange } = useAuth();
  return (
    <InsetWrap>
      <Title primary="You're not signed in." secondary="Sign in to access content." />
      <Button
        variant="contained"
        color="secondary"
        size="large"
        onClick={() => requestAuthChange("signIn")}
        loading={status === "loading"}
      >
        Sign in
      </Button>
    </InsetWrap>
  );
};
